
import { LINK_YUU_ERROR_CODE } from "@/constants/auth"
export default {
  name: "LinkError",
  asyncData({ route, app }) {
    const errCode = route.query.errCode
    const title = [app.i18n.t("auth.failedRegistration"), app.i18n.t("auth.failedToLinkYuuId")]
    let content = ""
    let titleIndex = 0
    switch (errCode) {
      case LINK_YUU_ERROR_CODE.REGISTER_MOBILE_DIFFERENT:
        content = app.i18n.t("auth.phoneNumberMismatch")
        break
      case LINK_YUU_ERROR_CODE.REGISTER_YUUID_BIND_ANOTHER_MOBILE:
        content = app.i18n.t("auth.yuuIdBoundToAnotherPhoneNumber")
        break
      case LINK_YUU_ERROR_CODE.REGISTER_MOBILE_HAS_BEEN_LOCKED:
        content = app.i18n.t("auth.phoneNumberLocked")
        break
      case LINK_YUU_ERROR_CODE.BIND_MOBILE_DIFFERENT:
        content = app.i18n.t("auth.phoneNumberMismatch")
        titleIndex = 1
        break
      case LINK_YUU_ERROR_CODE.BIND_YUUID_BIND_ANOTHER_MOBILE:
        content = app.i18n.t("auth.yuuIdBoundToAnotherPhoneNumber")
        titleIndex = 1
        break
      case LINK_YUU_ERROR_CODE.BIND_MOBILE_HAS_BEEN_LOCKED:
        content = app.i18n.t("auth.phoneNumberLocked")
        titleIndex = 1
        break
      default:
        break
    }
    return {
      title: title[titleIndex],
      content,
      errCode
    }
  },
  data() {
    return {
      errCode: ""
    }
  },
  methods: {
    handleClick() {
      const { errCode } = this
      console.log(errCode)
      if (
        errCode === LINK_YUU_ERROR_CODE.REGISTER_MOBILE_DIFFERENT ||
        errCode === LINK_YUU_ERROR_CODE.REGISTER_YUUID_BIND_ANOTHER_MOBILE ||
        errCode === LINK_YUU_ERROR_CODE.REGISTER_MOBILE_HAS_BEEN_LOCKED
      ) {
        this.$navigation.replace("/auth/login")
      } else {
        this.$navigation.replace("/")
      }
    }
  }
}
